import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 64FB01DD-0D60-4985-A367-02DAB7F66C59
 * name wave-arrow-down
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wave-arrow-down.svg
 * tags
 */
export const WaveArrowDownIcon = createSvgIcon(<><path d="M20 7H22V9H20C18.62 9 17.26 8.65 16 8C13.5 9.3 10.5 9.3 8 8C6.74 8.65 5.37 9 4 9H2V7H4C5.39 7 6.78 6.53 8 5.67C10.44 7.38 13.56 7.38 16 5.67C17.22 6.53 18.61 7 20 7M12 22L8 18H11V11H13V18H16L12 22Z" /></>, 'WaveArrowDownIcon');
export default WaveArrowDownIcon